import { render, staticRenderFns } from "./cModalPayment.vue?vue&type=template&id=3bd22e5b&scoped=true"
import script from "./cModalPayment.vue?vue&type=script&lang=js"
export * from "./cModalPayment.vue?vue&type=script&lang=js"
import style0 from "./cModalPayment.vue?vue&type=style&index=0&id=3bd22e5b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd22e5b",
  null
  
)

export default component.exports